import { FETCH_COOKIE } from '../actions/types';

const INTIAL_STATE = [];

export default (state = INTIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_COOKIE:
            return action.payload;
        default:
            return state;
    }
}